// extracted by mini-css-extract-plugin
export default {"container":"payee_container__-5fkK","profileImage":"payee_profileImage__BJYU-","profileDetails":"payee_profileDetails__z4e8x","email":"payee_email__cILh7"};